<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addModel('')">添加模型</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteModel">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getAsideNavs">刷新</el-button>
				<el-dropdown trigger="click" @command="setCommand">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-edit" v-for="(item,index) in modelNavs" :key="index" :command="item.mid">{{item.modelname}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-table
					:data="modelNavs"
					style="width: 100%;margin-bottom: 20px;"
					row-key="did"
					:stripe="true"
					:default-sort="{ prop: 'ctime', order: 'ascending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
					ref="multipleTable"
				>
					<el-table-column type="selection" width="55" :selectable="canCheck"></el-table-column>
					<el-table-column prop="mid" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="modelname" label="模型名称"></el-table-column>
					<el-table-column prop="lockin" label="添加方式">
						<template slot-scope="scope">
							{{ ['系统', '自主'][scope.row.lockin] }}
						</template>
					</el-table-column>
					<el-table-column prop="isbase" label="单页发布功能">
						<template slot-scope="scope">
							<i :class="scope.row.isbase ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="istsn" label="编号录入方式">
						<template slot-scope="scope">
							<i :class="scope.row.istsn ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="isalbum" label="相册功能">
						<template slot-scope="scope">
							<i :class="scope.row.isalbum ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="isques" label="投票功能">
						<template slot-scope="scope">
							<i :class="scope.row.isques ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="isfgid" label="表单功能">
						<template slot-scope="scope">
							<i :class="scope.row.isfgid ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column prop="isclass" label="启用状态">
						<template slot-scope="scope">
							<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="changeModelAttr(scope.row)">字段管理</el-button>
							<el-button type="warning" size="mini" @click="addModel(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
		</el-container>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			asideShow: true,
			modelNavs: [], //侧边栏操作菜单,模型筛选
			typeNavs: [], //分类筛选
			tNavDefault: '',
			tNavTabs: ['tnavs', 'tsnavs', 'ttnavs'],
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			mid: '',
			tid: '',
			selectedmodelIds: [],
			mlist: [],
			tlist: []
		};
	},
	mounted() {
		this.getAsideNavs();
	},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		getAsideNavs() {
			this.$axios({
				url: this.HOST + '/admin.document/asideNavsList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.modelNavs = res.data.modelNavs;
						this.typeNavs = res.data.typeNavs;
						this.mlist = res.data.mlist;
						this.tlist = res.data.tlist;
						console.log(this.paths);
					}
				})
				.catch(err => {});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].mid);
			}
			this.selectedmodelIds = arr;
			console.log(this.selectedmodelIds);
		},
		addCommand(command){
			console.log('add:',command);
		},
		setCommand(command){
			console.log('set:',command);
		},
		canCheck(row,index){
			if(row.lockin == 0){
				return false;
			}else{
				return true;
			}
		},
		changeModelAttr(scope){
			this.$router.push({path:'/documentModel/modelAttr',query:{'mid':scope.mid,'modelname':scope.modelname}});
		},
		// 全选
		selectAll() {
			this.modelNavs.map(item => {
				// 系统预设默认不允许删除
				if(item.lockin){
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			// this.selectedmodelIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.modelNavs.map(item => {
				// 系统预设默认不允许删除
				if(item.lockin){
					if (this.selectedmodelIds.indexOf(item.mid) != -1) {
						this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
					} else {
						diff.push(item.mid);
						this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
					}
				}
			});
			this.selectedmodelIds = diff;
			console.log(this.selectedmodelIds);
		},
		addModel(scope){
			if(scope){
				this.$router.push({path:'/documentModel/addModel',query:{'mid':scope.mid}});
			}else{
				this.$router.push({path:'/documentModel/addModel',query:{'mid':''}});
			}
		},
		deleteModel() {
			if (!this.selectedmodelIds.length) {
				this.$message.error('尚未选中任何模型！');
				return false;
			}
			this.$confirm('是否要删除所选模型？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.document/deleteModel',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							modelIds: this.selectedmodelIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getAsideNavs();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown{
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
			margin-right: 10px;
		}
	}
}
</style>
